export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL
export const BACKEND_PORT = process.env.REACT_APP_BACKEND_PORT
export const BACKEND_IP = 'https://coolcatstron.com'

export const MARKET_MIN_AMOUNT = 1500